<template>
  <TeamTable
    :isEditable="isUserAdminOnCompany"
    :members="members"
    :title="title"
    @edit-member-role="editMemberRole"
    @delete-member="deleteMember"
    @invite-members="inviteMembers"
  />
</template>

<script>
import CompanyService from "@/services/CompanyService"
import TeamTable from "@/components/ri3/project/TeamTable.vue"

export default {
  name: "TeamCompany",
  components: {
    TeamTable
  },
  computed: {
    company() {
      return this.$store.state.app.company
    },
    isUserAdminOnCompany() {
      return this.company.company_role == "administrator"
    },
    title() {
      return this.$t("views.team.members_of", { entity: this.company.name })
    }
  },
  data() {
    return {
      members: []
    }
  },
  mounted() {
    this.fetchMembers()
  },
  methods: {
    deleteMember(item) {
      CompanyService.removeFromTeam(this, item.id).then(() => {
        this.fetchMembers()
      })
    },
    editMemberRole(item) {
      const invite = {
        email: item.email,
        privileges: {
          inspector: item.role === "inspector",
          operator: item.role === "operator"
        }
      }

      CompanyService.sendInvite(this, this.company.pk, [invite])
    },
    fetchMembers() {
      this.loading = true
      CompanyService.getMembers(this.company.pk)
        .then(response => {
          this.members = response
        })
        .finally(() => {
          this.loading = false
        })
    },
    inviteMembers() {
      this.$router.push({ name: "CompanyInvitation" })
    }
  }
}
</script>
